import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as ArrowDown } from "../../assets/icons/arrow_down.svg";
import { ReactComponent as ArrowUp } from "../../assets/icons/arrow_up.svg";
import { ReactComponent as CheckIcon } from "../../assets/icons/checked.svg";

type InputProps = {
  placeholder: string;
  onChange?: any;
  className?: string;
  options?: any;
};

// When using Multiselect component you should use

// Resolve option identity/label tolerantly (see Select.tsx) so options coming
// from different APIs ({ id, name } vs { ID, Name }) don't render blank.
const getOptionId = (option: any) => {
  if (option == null) return undefined;
  if (typeof option !== "object") return option;
  return option.id ?? option.ID ?? option.value;
};

const getOptionLabel = (option: any) => {
  if (option == null) return "";
  if (typeof option !== "object") return String(option);
  return option.name ?? option.Name ?? option.label ?? option.value ?? "";
};

const MultiSelect = (props: InputProps) => {
  const [open, setOpen] = useState(false);
  const [selection, setSelection] = useState([]);
  const toggle = () => setOpen(!open);

  //   useEffect(effect: () => {

  //   })

  function handleOnClick(item) {
    console.log(item);
    if (!selection.some((current) => getOptionId(current) === getOptionId(item))) {
      setSelection([...selection, item]);
      props.onChange([...selection, item]);
    } else {
      let selectionAfterRemoval = selection;
      selectionAfterRemoval = selectionAfterRemoval.filter(
        (current) => getOptionId(current) !== getOptionId(item)
      );
      setSelection([...selectionAfterRemoval]);
      props.onChange([...selectionAfterRemoval]);
    }
  }
  function isItemInSelection(item) {
    if (selection.find((current) => getOptionId(current) === getOptionId(item))) {
      return true;
    } else {
      return false;
    }
  }

  console.log("open state", open);
  console.log("selection array", selection);

  return (
    <div className={`multi-select-container ${props.className}`}>
      <div className="multi-select-header" onClick={toggle}>
        <div className="multi-select-thumb-container">
          {selection.length > 0 ? (
            selection.map((item) => (
              <div className="multi-select-thumb">{getOptionLabel(item)}</div>
            ))
          ) : (
            <p className="multi-select-placeholder">{props.placeholder}</p>
          )}
        </div>
        {open ? <ArrowUp /> : <ArrowDown />}
      </div>
      <div className="multi-select-body">
        {open && (
          <ul className="multi-select-list">
            {props.options?.map((option: any, id: any) => (
              <button
                className={`multi-select-item ${isItemInSelection(option) &&
                  "multi-select-item-active"}`}
                value={getOptionLabel(option)}
                id={id}
                key={id}
                onClick={() => handleOnClick(option)}
              >
                <span>{getOptionLabel(option)}</span>
                <span>
                  {isItemInSelection(option) && (
                    <CheckIcon className="check-icon" />
                  )}
                </span>
              </button>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
export default MultiSelect;
